$(function() {
  polyfill();

  function polyfill () {
    if(!Modernizr.objectfit) {

      $('.js-object-fit').each(function(index, elem) {
        var $background = $(elem),
            classes = $background.data('component')+'__background';

        if($background.data('modifier')) {
          classes += ' ' + $background.data('component') + '__background--' + $background.data('modifier');
        }

        $background.replaceWith('<div class="' + classes + '" style="background-image: url(' + $background.attr('src') + ');"/>');
      });
    }
  }
});
